import { render } from "./ProposalSuppliersFormSection.vue?vue&type=template&id=6f99963c&ts=true"
import script from "./ProposalSuppliersFormSection.vue?vue&type=script&lang=ts"
export * from "./ProposalSuppliersFormSection.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__